function convertMachToMPH(num) {
  let eq =
    "Converting " +
    num +
    " mach to miles per hour: \n" +
    num +
    " * 761.207 = ";
  let rep = num * 761.207;
  return eq + rep.toFixed(3);
}

function convertMachToKnots(num) {
  let eq = "Converting " + num + " mach to knots: \n" + num + " * 661.4708 = ";
  let rep = num * 661.4708;
  return eq + rep.toFixed(3);
}

function convertMachToKPH(num) {
  let eq =
    "Converting " +
    num +
    " mach to kilometers per hour: \n" +
    num +
    " * 1225.044 = ";
  let rep = num * 1225.044;
  return eq + rep.toFixed(3);
}

export { convertMachToMPH, convertMachToKnots, convertMachToKPH };
